import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import staticFiles from "../services/basePath";
import {
  getDate,
  investmentDetailsPath,
  investmentPath,
  subscriptionManagerPath,
  investorPortFolioPath,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import SearchBar from "material-ui-search-bar";
import toast, { Toaster } from "react-hot-toast";
import ReactReadMoreReadLess from "react-read-more-read-less";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});
const columns = [
  { label: "Service type", id: "sername", minWidth: 150 },
  { label: "Quantity", id: "qty", minWidth: 150 },
  { label: "Payment date", id: "paymentdt", minWidth: 150, format: "Date" },
  {
    label: "Subscription date",
    id: "subscribeddt",
    minWidth: 150,
    format: "Date",
  },
  { label: "Payment amount", id: "amount", minWidth: 150 },
  { label: "Renewal date", id: "expiredt", minWidth: 150, format: "Date" },
  { label: "Order ID", id: "Order_ID", minWidth: 150 },
  { label: "Transaction ID", id: "Transaction_ID", minWidth: 150 },

  {
    label: "Agreement Copy",
    id: "agreement",
    minWidth: 150,
    align: "center",
    format: "link",
  },
  {
    label: "Invoice Receipt",
    id: "invoice",
    minWidth: 150,
    align: "center",
    format: "link",
  },
  { label: "Status", id: "Status", minWidth: 150, align: "center" },
  {
    label: "Payment method",
    id: "Payment_Method",
    minWidth: 150,
    align: "center",
  },
];

const subTextColumns = [
  { label: "Customer Name", id: "cust__custfirstname", minWidth: 150 },
  { label: "Employee Name", id: "emp__empfname", minWidth: 150 },
  { label: "Previous Expiry", id: "previous_exp", minWidth: 150, type: "date" },
  { label: "Current Expiry", id: "current_exp", minWidth: 150, type: "date" },
  { label: "Created Date", id: "createddt", minWidth: 150, type: "date" },
  { label: "Comments", id: "comment", minWidth: 150, type: "comments" },
];

function SubscriptionManager() {
  const classes = useStyles();
  const history = useHistory();
  const [publishedActive, setPublishedActive] = useState(true);
  const [archivedActive, setArchivedActive] = useState(false);
  const location = useLocation();
  const myparam = location.state;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const viewInvestmentDetails = (object) => {
    history.push({
      pathname: investmentDetailsPath,
      state: myparam,
    });
  };
  const [setSubText, getSubText] = useState([]);
  useEffect(() => {
    // alert(myparam.customer_id)
    getData();
  }, []);

  const getData = () => {
    if (myparam && myparam.customer_id) {
      toast.loading("Please wait...");
      http
        .get("/subscription_manager/" + myparam.customer_id)
        .then((response) => {
          toast.dismiss();
          // (response.data.sub_ext);
          if (response && response.data.data && response.data.data.length > 0) {
            setOriginalRows(response.data.data);
            setRows(response.data.data);
          }
          if (
            response &&
            response.data.sub_ext &&
            response.data.sub_ext.length > 0
          ) {
            getSubText(response.data.sub_ext);
          }
        })
        .catch((error) => {
          console.log("error");
        });
    }
  };
  const makeActive = (event) => {
    setPublishedActive(!publishedActive);
    setArchivedActive(!archivedActive);
    if (event === "portfolio") {
      if (myparam && myparam.customer_id) {
        history.push({
          pathname: investorPortFolioPath,
          state: myparam,
        });
      }
    }
  };

  const [extension, setExtension] = useState(false);
  const [setComment, getComment] = useState("");
  const extensionChange = (e) => {
    // ((e.target.value).length);
    getComment(e.target.value);
    if (e.target.value.length === 0) {
      setExtension(false);
    } else {
      setExtension(true);
    }
  };

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const openModel = () => {
    setOpen(true);
  };

  const sendExtension = {
    id: myparam.customer_id,
    comment: setComment,
  };

  const submitExtension = () => {
    // alert('yes')
    http
      .post("/subscription_extension", sendExtension)
      .then((res) => {
        if (res.data.statusCode === 0) {
          toast.success(res.data.data);
          setOpen(false);
          getData();
          getComment("");
        } else if (res.data.statusCode === 1) {
          toast.error(res.data.data);
          setOpen(false);
        }
      })
      .catch((err) => {});
  };

  // alert()
  return (
    <div className={(classes.root, "pb30")}>
      {/* <AppBar
        position="static"
        style={{ marginBottom: 5, paddingTop: 3, paddingBottom: 3 }}
      >
        <Grid container component="main">
          {localStorage.getItem("empRole") === "MF Manager" ||
          localStorage.getItem("empRole") === "MF Executive" || localStorage.getItem("empRole") === "Franchise" ? (
            ""
          ) : (
            <Grid item xs={12} sm={6} md={6}>
              <ButtonGroup className="overviewbar">
                <Button
                  variant={publishedActive ? "contained" : "outlined"}
                  color="primary"
                  style={{ marginLeft: 10, borderRadius: 60 }}
                  name="invOverView"
                  onClick={history.push({
                    pathname: investmentPath,
                  })}
                >
                  OverView
                </Button>
                <Button
                  variant={archivedActive ? "contained" : "outlined"}
                  color="primary"
                  style={{ marginLeft: 10, borderRadius: 60 }}
                  onClick={() => makeActive("portfolio")}
                  name="archivedPostsButton"
                >
                  Portfolio
                </Button>
              </ButtonGroup>
            </Grid>
          )}
        </Grid>
      </AppBar> */}
      {/* <Grid container className="mt30" style={{ marginBottom: 20 }}>
        <Grid item xs={12} sm={6} md={5} className="overviewbar">
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={viewInvestmentDetails}
          >
            Back
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={6} className="overviewbar">
          <Typography color="textPrimary" variant="h5">
            Subscription Details
          </Typography>
        </Grid>
      </Grid> */}
      <Paper style={{ marginBlock: 10 }}>
        <Grid
          container
          component="main"
          style={{ padding: 5, justifyContent: "space-between" }}
        >
          <Grid item>
            <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={() => cancelSearch()}
              style={{ height: "auto", padding: "5px 0" }}
            />
          </Grid>
          <Grid item>
            <TablePagination
              rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Grid>
        </Grid>

        <TableContainer>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index + "a"}
                    >
                      {columns.map((column, index) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            key={index + column.id}
                            align={column.align}
                            style={{ padding: 15 }}
                          >
                            {column.format && typeof value === "number" ? (
                              column.format(value)
                            ) : column.id === "detailsButton" ? (
                              <Button
                                variant="contained"
                                color="primary"
                                style={{ borderRadius: 20 }}
                                onClick={() => viewInvestmentDetails(row)}
                              >
                                {" "}
                                View Details{" "}
                              </Button>
                            ) : column.format === "Date" ? (
                              getDate(value)
                            ) : column.format === "boolean" &&
                              row[column.id] ? (
                              "Yes"
                            ) : column.format === "boolean" &&
                              !row[column.id] ? (
                              "No"
                            ) : column.format === "link" &&
                              value &&
                              value !== "" ? (
                              <Link
                                variant="body2"
                                href={staticFiles + value}
                                target="_blank"
                              >
                                {value}
                              </Link>
                            ) : value ? (
                              value
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {/* 
      {localStorage.getItem("empRole") === "CTO" ? (
        <>
          <div
            style={{
              marginTop: 30,
              display: "flex",
              columnGap: 20,
              flexWrap: "wrap",
              marginBottom: 30,
            }}
          >
            <>
              <textarea
                style={{ marginBottom: 10 }}
                rows={6}
                cols={70}
                placeholder="comments"
                value={setComment}
                onChange={extensionChange}
              ></textarea>
            </>
            <div
              style={{
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              <Button
                color="primary"
                variant="contained"
                disabled={!extension ? true : false}
                onClick={openModel}
              >
                Extension
              </Button>
            </div>
          </div>
        </>
      ) : (
        ""
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Typography>
            Do you want to update subscription for 2 months?
          </Typography>
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            No
          </Button>
          <Button
            autoFocus
            onClick={submitExtension}
            variant="contained"
            color="primary"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* {setSubText.length != 0 ? (
        <TableContainer style={{ marginBottom: 20 }}>
          <Table>
            <TableHead>
              <TableRow>
                {subTextColumns.map((item) => {
                  return <TableCell>{item.label}</TableCell>;
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {setSubText
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow>
                      {subTextColumns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell>
                            {column.type === "date" ? (
                              getDate(value)
                            ) : column.type === "comments" ? (
                              <ReactReadMoreReadLess
                                charLimit={10}
                                readMoreText={"More ▼"}
                                readLessText={"Less ▲"}
                                readMoreStyle={{
                                  color: "#2835d5",
                                  cursor: "pointer",
                                }}
                                readLessStyle={{
                                  color: "#2835d5",
                                  cursor: "pointer",
                                }}
                              >
                                {!value ? "N/A" : value}
                              </ReactReadMoreReadLess>
                            ) : value ? (
                              value
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        ""
      )} */}
    </div>
  );
}

export default SubscriptionManager;
